export enum EstimatorPath {
    Search = 'property-management',
    AddressDetails = 'property-management/estimator/property-details',
    UserDetails = 'property-management/estimator/user-details',
    Error = 'property-management/estimator/contact',
    Result = 'property-management/estimator/result',
    ThankYou = 'property-management/estimator/result',
}

export const SegmentEvents: Readonly<Record<EstimatorPath, string>> = Object.freeze({
    ['']: 'step-address',
    [EstimatorPath.Search]: 'step-address',
    [EstimatorPath.AddressDetails]: 'step-features',
    [EstimatorPath.UserDetails]: 'step-contact',
    [EstimatorPath.Error]: 'step-error',
    [EstimatorPath.Result]: 'finish',
    ...(EstimatorPath.Result === EstimatorPath.ThankYou
        ? {}
        : { [EstimatorPath.ThankYou]: 'finish' }),
});
